import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const ServicesPage = lazy(() => import('../pages/services/page'));
const GalleryPage = lazy(() => import('../pages/gallery/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const SocialPage = lazy(() => import('../pages/social/page'));
const BlogPage = lazy(() => import('../pages/blog/page'));
const EstimateAirbnbIncome2026 = lazy(() => import('../pages/blog/estimate-airbnb-income-2026/page'));
const Top7AirbnbMistakesToAvoid = lazy(() => import('../pages/blog/top-7-airbnb-mistakes-to-avoid/page'));
const CartPage = lazy(() => import('../pages/cart/page'));
const CheckoutPage = lazy(() => import('../pages/checkout/page'));
const CheckoutSuccessPage = lazy(() => import('../pages/checkout/success/page'));
const LoginPage = lazy(() => import('../pages/login/page'));
const SignupPage = lazy(() => import('../pages/signup/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/services',
    element: <ServicesPage />,
  },
  {
    path: '/gallery',
    element: <GalleryPage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '/social',
    element: <SocialPage />,
  },
  {
    path: '/blog',
    element: <BlogPage />,
  },
  {
    path: '/blog/estimate-airbnb-income-2026',
    element: <EstimateAirbnbIncome2026 />,
  },
  {
    path: '/blog/top-7-airbnb-mistakes-to-avoid',
    element: <Top7AirbnbMistakesToAvoid />,
  },
  {
    path: '/blog/5-star-airbnb-reviews-guide',
    element: lazy(() => import('../pages/blog/5-star-airbnb-reviews-guide/page')),
  },
  {
    path: '/blog/airbnb-pricing-strategies-2026',
    element: lazy(() => import('../pages/blog/airbnb-pricing-strategies-2026/page')),
  },
  {
    path: '/blog/short-term-rental-legal-compliance-guide',
    element: lazy(() => import('../pages/blog/short-term-rental-legal-compliance-guide/page')),
  },
  {
    path: '/cart',
    element: <CartPage />,
  },
  {
    path: '/checkout',
    element: <CheckoutPage />,
  },
  {
    path: '/checkout/success',
    element: <CheckoutSuccessPage />,
  },
  {
    path: '/login',
    element: <LoginPage />,
  },
  {
    path: '/signup',
    element: <SignupPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
